import React from "react";
import ReactDOM from "react-dom/client";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import App from "./App";

const theme = createTheme(
  {
    typography: {
      fontFamily: '"Noto Sans", sans-serif',
    },
    palette: {
      primary: {
        main: "#5085A5",
      },
      secondary: {
        main: "#dc004e",
      },
    },
  },
  {
    cssVariables: true,
  }
);

const rootElement = document.getElementById("root");

const root = ReactDOM.createRoot(rootElement!);
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
    },
  },
});
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </ThemeProvider>
);
